import Vue from "vue";

const base64 = {
  install(Vue) {
    Vue.prototype.$appBase64 = {
      decodeBase64ToString: function (data) {
        var hexString = this.decodeBase64ToHex(data);
        var characterString = "";
        var regexp = /\\x[0-1][0-9a-f]|\\x20|\\x7f|\\x[8-9a-f][0-9a-f]/;

        for (var i = 0; i < hexString.length; i += 4) {
          var hex =
            hexString[i] +
            hexString[i + 1] +
            hexString[i + 2] +
            hexString[i + 3];

          if (regexp.test(hex)) {
            characterString += "[" + hex + "]";
          } else {
            characterString += String.fromCharCode(
              parseInt(hex.replace("\\x", ""), 16)
            );
          }
        }
        return characterString;
      },
      decodeBase64ToHex: function (data) {
        var base64 =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

        var decode = "";
        var length = data.length;

        for (var i = 0; i < length; i += 4) {
          var code =
            ((base64.indexOf(data.charAt(i)) & 0x3f) << 18) |
            ((base64.indexOf(data.charAt(i + 1)) & 0x3f) << 12) |
            ((base64.indexOf(data.charAt(i + 2)) & 0x3f) << 6) |
            (base64.indexOf(data.charAt(i + 3)) & 0x3f);

          decode +=
            this.makeHexString(((code >> 16) & 0xff).toString(16)) +
            this.makeHexString(((code >> 8) & 0xff).toString(16)) +
            this.makeHexString((code & 0xff).toString(16));
        }

        var equals = data.match(/=/g);

        if (equals) {
          if (equals.length == 2) {
            return decode.slice(0, -8); // remove \x00\x00
          } else if (equals.length == 1) {
            return decode.slice(0, -4); // remove \x00
          }
        }

        return decode;
      },
      makeHexString: function (data) {
        var hexString = "";

        hexString += "\\x";

        if (data.length == 1) {
          hexString += "0" + data;
        } else {
          hexString += data;
        }

        return hexString;
      },
    };
  },
};
Vue.use(base64);
